
/**
 * Init
 */
$(document).ready(function () {
    initSwipeCarousel();
});

/**
 * Handles the swipe gesture on touch screens to open/close the main menu
 */
function initSwipeCarousel() {
    $('.carousel .item').each(function(i, item) {
        let hammer = new Hammer(item);
        let carousel = $(item).parents('.carousel')[0];

        hammer.on('swipeleft', function() {
            $(carousel).carousel('next');
        });

        hammer.on('swiperight', function() {
            $(carousel).carousel('prev');
        });
    });
}